module.exports = "/_next/static/images/banner-logo-bfefdf4bec7d8e7b2809e72bc684e602.png";